import { Alert } from "antd"
import React, { useEffect } from "react"

import { generateDocumentTitle } from "../../../constants/document-title.ts"
import { useAppSelector } from "../../../hooks/use-app-selector.ts"
import {
  selectActiveBranchId,
  selectCompanyIsMultiBranch
} from "../../Branches/redux/branches.slice.ts"
import { CompanyDefaultsSubTabs } from "../components/common/CompanyDefaultsSubTabs.tsx"
import { SettingsTemplatesHub } from "../components/settings-templates/SettingsTemplatesHub.tsx"

export default function SettingsTemplatesPage() {
  const isMultiBranch = useAppSelector(selectCompanyIsMultiBranch)
  const activeBranchId = useAppSelector(selectActiveBranchId)
  const isBranchScope = isMultiBranch && !!activeBranchId

  useEffect(() => {
    generateDocumentTitle("Settings Templates")
  }, [])

  return (
    <div className="flex-1 flex flex-col gap-3 w-full">
      <CompanyDefaultsSubTabs />
      {isBranchScope && (
        <Alert
          type="info"
          showIcon
          message="Templates are set company-wide and are not yet customizable per branch."
        />
      )}
      <SettingsTemplatesHub />
    </div>
  )
}
